export const ASSETS = {
  logo: "/img/logo.jpg",
  palmDiagram: "/img/palm-diagram.jpg",
  hero: "/img/hero.jpg",
  goodExample: "https://images.pexels.com/photos/6642895/pexels-photo-6642895.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  closeup: "https://images.pexels.com/photos/4046563/pexels-photo-4046563.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
